import {KeywordSet} from "../KeywordSet.ts";

export const MusicGenresSet: KeywordSet = {
	id: "music-genres",
	name: "Music Genres",
	description: "How many music genres can you guess?",
	time: 300,
	keywords: [
		"Pop",
		"Rock",
		"Hip Hop",
		"Rap",
		"R&B",
		"Jazz",
		"Blues",
		"Soul",
		"Funk",
		"Classical",
		"Opera",
		"Electronic",
		"EDM",
		"House",
		"Techno",
		"Trance",
		"Dubstep",
		"Drum and Bass",
		"Reggae",
		"Ska",
		"Dancehall",
		"Country",
		"Bluegrass",
		"Folk",
		"Indie",
		"Alternative",
		"Punk",
		"Hard Rock",
		"Heavy Metal",
		"Thrash Metal",
		"Death Metal",
		"Black Metal",
		"Glam Rock",
		"Progressive Rock",
		"Post-Rock",
		"Grunge",
		"New Wave",
		"Synthpop",
		"Industrial",
		"Ambient",
		"Chillout",
		"Lo-fi",
		"Trip Hop",
		"Breakbeat",
		"Disco",
		"Electro",
		"Gospel",
		"Christian",
		"Worship",
		"World",
		"Afrobeat",
		"K-Pop",
		"J-Pop",
		"C-Pop",
		"Latin",
		"Reggaeton",
		"Bachata",
		"Salsa",
		"Merengue",
		"Tango",
		"Flamenco",
		"Bossa Nova",
		"Samba",
		"Bollywood",
		"Indian Classical",
		"Qawwali",
		"Arabic",
		"Turkish",
		"Celtic",
		"Polka",
		"Tejano",
		"Zydeco",
		"Jazz Fusion",
		"Swing",
		"Big Band",
		"Chiptune",
		"Video Game",
		"Soundtrack",
		"Film Score",
		"Musical Theatre",
		"Experimental",
		"Noise",
		"Avant-Garde",
		"Math Rock",
		"Shoegaze",
		"Dream Pop",
		"Emo",
		"Screamo",
		"Post-Hardcore",
		"Metalcore",
		"Crunkcore",
		"Trap",
		"Cloud Rap",
		"Boom Bap",
		"Freestyle",
		"Grime",
		"UK Garage",
		"Drill",
		"Phonk",
		"Hyperpop",
		"Synthwave",
		"Vaporwave",
		"Future Bass",
		"Moombahton",
		"Glitch",
		"IDM",
		"Downtempo",
		"Tropical House",
		"Melodic Techno",
		"Hardstyle",
		"Psytrance",
		"Goa",
		"Eurodance",
		"Italo Disco",
		"Krautrock",
		"Neoclassical",
		"Medieval",
		"Baroque",
		"Renaissance",
		"Gregorian Chant",
		"Choral",
		"New Age",
		"Spoken Word",
		"Comedy",
		"Children’s Music",
		"Holiday",
		"Christmas"
	]
};
